import { Dialog } from '@factorialco/f0-react/dist/experimental'
import {
  EngagementArchiveSurveyDocument,
  EngagementSurveysDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  surveyId: number
  onCancel?: () => void
  onSuccess?: () => void
}

export function ArchiveSurveyDialog({ surveyId, onCancel, onSuccess }: Props) {
  const [archiveSurvey] = useMutation(EngagementArchiveSurveyDocument, {
    extractorFn: (data) => data.surveysMutations.archiveSurveysSurvey,
    refetchQueries: [EngagementSurveysDataCollectionDocument],
  })

  return (
    <Dialog
      open
      onClose={onCancel}
      header={{
        title: i18n.t('surveys.archive_survey_dialog.title'),
        description: i18n.t('surveys.archive_survey_dialog.description'),
        type: 'critical',
      }}
      actions={{
        primary: {
          label: i18n.t('common.archive'),
          variant: 'critical',
          onClick: async () => {
            const response = await archiveSurvey({
              variables: {
                surveyId: surveyId.toString(),
              },
            })

            const handled = handleResult(response, () => {})

            if (handled.success) {
              onSuccess?.()
            }
          },
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: () => onCancel?.(),
        },
      }}
    />
  )
}
